<template>
  <div id="login">
    <el-container>
      <el-main>
        <p class="welcome">
          <img :src="sysConfig.homepageLogo || '../assets/mume_logo.png'">
        </p>
        <div class="login-container">
          <img class="left-img" src="https://pic.mumetech.com/mume_mgr_login.png" />

          <el-form :model="loginForm" status-icon class="login-form">
            <p style="font-size: 40px;color: #007aff;font-weight: bold;text-align: left;margin:0;margin-bottom: 22px;">
              欢迎登陆</p>
            <p style="font-size: 24px;color: #000;font-weight: 400;text-align: left;margin:0;margin-bottom: 22px;">
              {{ sysConfig.sysName }}—让社群管理更轻松
            </p>
            <el-form-item>
              <el-input v-model="loginForm.username" placeholder="请输入账户名称">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="password" v-model="loginForm.password" placeholder="请输入账户密码">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" :loading="isLoading" type="primary" @click="submitForm()">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <el-footer>
        <p>{{ sysConfig.copyrightEn }}&nbsp;&nbsp;{{ sysConfig.copyrightCn }}</p>
        <p>备案号：<a :href="sysConfig.recordLink" style="color:#fff;text-decoration:none;">{{ sysConfig.recordNo }}</a></p>
      </el-footer>
      <!-- <el-footer>
          <p>备案号：<a href="https://beian.miit.gov.cn">苏ICP备19011731号</a>&nbsp;&nbsp;Copyright2021 MUME Co.Ltd</p>
          <p>版权所有：南京木美传媒科技有限公司</p>
        </el-footer> -->
    </el-container>
    <!-- <div>
      <div class="logo">
        <img :src="sysConfig.homepageLogo || '../assets/mume_logo.png'">
        <p>{{sysConfig.sysName}}</p>
        <div>
          <span>智慧</span>
          <span>循环</span>
          <span>高效</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import utils from "../utils/utils"
import request from '../utils/httpRequest'
export default {
  name: 'login',
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        validCode: ""
      },
      isLoading: false,
      sysConfig: {
        sysName: "",
        homepageLogo: "../assets/mume_logo.png"
      }
    }
  },
  created() {
    this.getSysConfig()
  },
  methods: {
    getSysConfig() {
      // request.get("/api/sysConfig/query").then(res => {
      //     if(res.data.code == 0){
      //       this.sysConfig.sysName =  res.data.obj.sysName ? res.data.obj.sysName:"卡券回收管理系统平台"
      //       this.sysConfig.homepageLogo = res.data.obj.homepageLogo
      //       document.title = res.data.obj.shareTitle ? res.data.obj.shareTitle:this.sysConfig.sysName
      //       if(res.data.obj.shareLogo){
      //         var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      //         link.type = 'image/x-icon';
      //         link.rel = 'shortcut icon';
      //         link.href = res.data.obj.shareLogo;
      //         document.getElementsByTagName('head')[0].appendChild(link);
      //       }
      //     }
      //   });
      request.get("/api/sysConfig/getSysConfigByType?type=2").then(res => {
        if (res.data.code == 0) {
          this.sysConfig = res.data.obj;
          this.sysConfig.sysName = res.data.obj.sysName
            ? res.data.obj.sysName
            : "木美会员权益管理";
          this.sysConfig.homepageLogo = res.data.obj.homepageLogo;
          document.title = res.data.obj.shareTitle
            ? res.data.obj.shareTitle
            : this.sysConfig.sysName;
          if (res.data.obj.shareIcon) {
            var link = document.querySelector('link[rel*="icon"]')
            link.href = res.data.obj.shareIcon;
          }
        }
      });
    },
    submitForm() {
      let success = (response) => {
        if (response.data.code === 0) {
          let obj = response.data.obj;
          let user = response.data.obj.user;
          this.setCookie("loginName", user.loginName ? user.loginName : user.userName, 1)
          this.setCookie("actualName", user.actualName ? user.actualName : "平台管理超级用户", 1)
          this.setCookie("headPic", user.headPic ? user.headPic : "", 1)
          this.setCookie("companyName", obj.companyName ? obj.companyName : "", 1)
          this.setCookie("deptName", obj.deptName ? obj.deptName : "", 1)
          this.setCookie("companyId", user.companyId ? user.companyId : "", 1)
          this.setCookie("deptId", user.deptId ? user.deptId : "", 1)
          this.setCookie("userId", user.id, 1)
          this.$router.replace({ path: "/index" })
        } else {
          this.$message.error(response.data.msg)
        }
      }
      const that = this;
      this.isLoading = true;
      request.post('/api/user/login', this.loginForm).then(res => {
        success(res);
      }).catch(e => {
        that.isLoading = false;
        if (e && e.msg)
          this.$message.error(e.msg)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#login {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100vw;
  height: 100vh;
  background: url(https://pic.mumetech.com/mume_mgr_bg.png) no-repeat center;
  background-size: 100% 100%;

  section {
    flex: none;

    .el-header,
    .el-footer {
      color: #fff;
      text-align: center;
    }

    .el-footer {
      background-color: transparent;

      p {
        padding: 0;
        margin: 0;
        font-size: 14px;
        line-height: 30px;
      }
    }

    .el-main {
      color: #333;
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .login-container {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        background: url(https://pic.mumetech.com/mume_mgr_login_bg.png) no-repeat center;
        background-size: 100% 100%;

        width: calc(100vw / 1918 * 1516);
        height: calc(100vw / 1918 * 770);

        .left-img {
          width: calc(100vw / 1918 * 556);
          height: calc(100vw / 1918 * 531);
        }
      }

      .welcome {
        text-align: left;

        img {
          width: 93px;
          height: 61px;
        }
      }

      .login-form {
        width: calc(100vw / 1918 * 443);

        .login-btn {
          width: 100%;
          background-color: #007aff;
        }
      }
    }
  }

}
</style>
<style lang="less">
#login {
  .el-input-group__prepend {
    width: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue